var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    rx: 7.5,
    fill: "#F3FCF5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3983 10.9102H14.8057C14.3023 10.9102 13.8195 11.1101 13.4635 11.4661C13.1076 11.8221 12.9076 12.3049 12.9076 12.8083V27.9935C12.9076 28.4969 13.1076 28.9797 13.4635 29.3357C13.8195 29.6917 14.3023 29.8916 14.8057 29.8916H26.1946C26.6981 29.8916 27.1809 29.6917 27.5368 29.3357C27.8928 28.9797 28.0928 28.4969 28.0928 27.9935V16.6046L22.3983 10.9102Z",
    stroke: "#219653",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3982 10.9102V16.6046H28.0926",
    stroke: "#219653",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2962 21.351H16.7036",
    stroke: "#219653",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2962 25.2457H16.7036",
    stroke: "#219653",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6018 17.5532H17.6527H16.7036",
    stroke: "#219653",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.a86fe873dbb1270d6ecbae20d245c184.svg";
export { ForwardRef as ReactComponent };